import type { Router } from 'vue-router';

import { useErrorStore } from '@/shared/stores/error';

import type { ErrorState } from '@/shared/stores/types';

/**
 * Registers the error-clearing middleware on the router.
 *
 * - `beforeEach` snapshots the current error reference.
 * - `afterEach` clears the error only when it is the SAME reference, i.e. it is
 *   stale from the previous page. If a guard (the permission middleware, say)
 *   called `setError` during the navigation, the reference differs and
 *   `afterEach` leaves it intact.
 *
 * Must be registered BEFORE the other `beforeEach` guards so the snapshot is
 * taken first.
 */
export const registerErrorMiddleware = (router: Router): void => {
  let errorBeforeNavigation: ErrorState | null = null;

  router.beforeEach(() => {
    const errorStore = useErrorStore();
    errorBeforeNavigation = errorStore.error;
  });

  router.afterEach(() => {
    const errorStore = useErrorStore();

    if (errorStore.error && !errorStore.error.critical && errorStore.error === errorBeforeNavigation) {
      errorStore.clearError();
    }
  });
};
